import { render, staticRenderFns } from "./ProgramsEdit.vue?vue&type=template&id=9bdc49c4"
import script from "./ProgramsEdit.vue?vue&type=script&lang=js"
export * from "./ProgramsEdit.vue?vue&type=script&lang=js"
import style0 from "./ProgramsEdit.vue?vue&type=style&index=0&id=9bdc49c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports